import classNames from 'classnames';
import { CbButton } from 'ui/components/Buttons/CbButton';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import styles from './../NavigationContainer.module.css';
export const NavigationButton = ({
  direction,
  shouldShow,
  onClickAction,
  isDisabled
}) => {
  const isPrev = direction === 'prev';
  const iconName = isPrev ? 'arrowleft' : 'arrowright';
  const iconColor = 'white';
  const classes = classNames(styles.navigationButton, {
    [styles.prev]: isPrev,
    [styles.next]: !isPrev,
    [styles.disabled]: isDisabled
  });
  return <div className={classes} onClick={() => !isDisabled && onClickAction()} data-sentry-component="NavigationButton" data-sentry-source-file="NavigationButton.tsx">
      {shouldShow && <CbButton variant="ghost-on-dark" round width="48px" height="48px" onClick={onClickAction} isDisabled={isDisabled} data-testid={isPrev ? 'guide-prev-button' : 'guide-next-button'}>
          {ICON_BY_NAME[iconName]({
        height: '14px',
        color: iconColor
      })}
        </CbButton>}
    </div>;
};